export const EXCMDEVICEBRAND_CREATE_RESET = 'EXCMDEVICEBRAND_CREATE_RESET'
export const EXCMDEVICEBRAND_CREATE_SET_CREATED = 'EXCMDEVICEBRAND_CREATE_SET_CREATED'
export const EXCMDEVICEBRAND_CREATE_SET_ERROR = 'EXCMDEVICEBRAND_CREATE_SET_ERROR'
export const EXCMDEVICEBRAND_CREATE_SET_VIOLATIONS = 'EXCMDEVICEBRAND_CREATE_SET_VIOLATIONS'
export const EXCMDEVICEBRAND_CREATE_TOGGLE_LOADING = 'EXCMDEVICEBRAND_CREATE_TOGGLE_LOADING'
